import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';
import AdminContacts from './components/ui/AdminContacts';
import { isAdmin } from './utils/auth';
import MobileMarketing from './components/MobileMarketing';
import SeoOptimization from './components/SeoOptimization';
import SocialMediaMarketing from './components/SocialMediaMarketing';
import ContentMarketing from './components/ContentMarketing';
import WebDevelopment from './components/WebDevelopment';
import VideoMarketing from './components/VideoMarketing';
import Testimonials from './components/Testimonials';
import CaseStudies from './components/CaseStudies';
import FAQ from './components/FAQ';
import Pricing from './components/Pricing';
import Blog from './components/Blog';
import Newsletter from './components/Newsletter';
import Team from './components/Team';
import NotFound from './components/NotFound';
import PrivacyPolicy from './components/privacyPolicy';
import TermsOfService from './components/TermCondition';

const App = () => {
  const location = useLocation();

  // Always scroll to top on page load/refresh
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Only on initial mount

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen bg-[#0f1a29]">
      <Navbar />
      <div className="">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Services />
                <About />
                <Testimonials />
                <Contact />
                <Footer />
              </>
            }
          />
          <Route
            path="/services/seo-optimization"
            element={<SeoOptimization />}
          />
          <Route
            path="/services/social-media-marketing"
            element={<SocialMediaMarketing />}
          />
          <Route
            path="/services/content-marketing"
            element={<ContentMarketing />}
          />
          <Route
            path="/services/web-development"
            element={<WebDevelopment />}
          />
          <Route
            path="/services/mobile-marketing"
            element={<MobileMarketing />}
          />
          <Route
            path="/services/video-marketing"
            element={<VideoMarketing />}
          />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/team" element={<Team />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path="/admin/contacts"
            element={isAdmin() ? <AdminContacts /> : <Navigate to="/" />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsOfService />} />
        </Routes>
      </div>
    </div>
  );
};

export default App; 